var map = {
	"./tapcoin/30tip.png": 85750,
	"./tapcoin/BIGTON.png": 92775,
	"./tapcoin/TONwallet.png": 1280,
	"./tapcoin/activity-top.png": 81522,
	"./tapcoin/airdrop-big.png": 86780,
	"./tapcoin/airdrop-channel.png": 85745,
	"./tapcoin/airdrop-freemint.png": 44746,
	"./tapcoin/airdrop-icons.png": 92227,
	"./tapcoin/airdrop-left-bg.jpg": 67310,
	"./tapcoin/airdrop-ok.png": 2664,
	"./tapcoin/airdrop-pass.png": 64079,
	"./tapcoin/airdrop-right-bg.jpg": 78149,
	"./tapcoin/airdrop-tap-icon1.png": 65994,
	"./tapcoin/airdrop-tap-icon2.png": 43121,
	"./tapcoin/airdrop-tap-icon3.png": 57056,
	"./tapcoin/airdrop-tap-icon4.png": 86026,
	"./tapcoin/airdrop-tap-icon5.png": 48587,
	"./tapcoin/airdrop-tap-icon6.png": 75609,
	"./tapcoin/airdrop-tap-r2-icon1.png": 85316,
	"./tapcoin/airdrop-tap-r2-icon10.png": 96393,
	"./tapcoin/airdrop-tap-r2-icon2.png": 50368,
	"./tapcoin/airdrop-tap-r2-icon3.png": 7814,
	"./tapcoin/airdrop-tap-r2-icon4.png": 69763,
	"./tapcoin/airdrop-tap-r2-icon5.png": 77241,
	"./tapcoin/airdrop-tap-r2-icon6.png": 84846,
	"./tapcoin/airdrop-tap-r2-icon7.png": 94372,
	"./tapcoin/airdrop-tap-r2-icon8.png": 97645,
	"./tapcoin/airdrop-tap-r2-icon9.png": 24860,
	"./tapcoin/airdrop-tickets.png": 74318,
	"./tapcoin/airdrop-top-bg.png": 59515,
	"./tapcoin/airdrop-wallet.png": 70284,
	"./tapcoin/airdrop.png": 73971,
	"./tapcoin/award.png": 78171,
	"./tapcoin/award_tip.jpg": 35234,
	"./tapcoin/bitget.jpg": 1329,
	"./tapcoin/bnb_logo.png": 62243,
	"./tapcoin/boost-list-icon-1.png": 15035,
	"./tapcoin/boost-list-icon-2.png": 72043,
	"./tapcoin/boost-list-icon-3.png": 43444,
	"./tapcoin/boost-list-icon-4.png": 4681,
	"./tapcoin/boost-list-icon-5.png": 67241,
	"./tapcoin/boost-list-icon-6.png": 2970,
	"./tapcoin/browser.png": 22461,
	"./tapcoin/btn-icon-boost.png": 97498,
	"./tapcoin/btn-icon-frens.png": 39246,
	"./tapcoin/code-icon-0.png": 2913,
	"./tapcoin/daily-invite.png": 49729,
	"./tapcoin/daily_icon.png": 29094,
	"./tapcoin/diamond.png": 97669,
	"./tapcoin/earn-btn-bg.jpg": 55343,
	"./tapcoin/earn-head-icon-gift.png": 59216,
	"./tapcoin/earn-icon-0.png": 43847,
	"./tapcoin/earn-key.png": 50899,
	"./tapcoin/earn-list-icon-1.png": 349,
	"./tapcoin/earn-list-icon-2.png": 45090,
	"./tapcoin/earn-list-icon-gift.png": 95596,
	"./tapcoin/earn-logo.png": 44577,
	"./tapcoin/finish.png": 26059,
	"./tapcoin/frens-1.png": 44604,
	"./tapcoin/frens-2.png": 32854,
	"./tapcoin/frens-3.png": 28306,
	"./tapcoin/gate.jpg": 94279,
	"./tapcoin/icon-frens.png": 93011,
	"./tapcoin/icon-pph-1.png": 37825,
	"./tapcoin/icon-pph-2.png": 42220,
	"./tapcoin/index-bg-1.jpg": 62848,
	"./tapcoin/index-bg.jpg": 63156,
	"./tapcoin/index-btn-activity.png": 76101,
	"./tapcoin/index-btn-airdrop.png": 21553,
	"./tapcoin/index-btn-appcenter.png": 22110,
	"./tapcoin/index-btn-boost.png": 30586,
	"./tapcoin/index-btn-earn.png": 3263,
	"./tapcoin/index-btn-frens.png": 94744,
	"./tapcoin/index-btn-home.png": 20638,
	"./tapcoin/index-btn-icon-1.png": 36013,
	"./tapcoin/index-btn-icon-2.png": 7031,
	"./tapcoin/index-btn-icon-21.png": 12586,
	"./tapcoin/index-btn-icon-3.png": 64551,
	"./tapcoin/index-btn-icon-4.png": 66708,
	"./tapcoin/index-btn-lottery.png": 95357,
	"./tapcoin/index-btn-mine.png": 6368,
	"./tapcoin/index-btn-wallet.png": 46198,
	"./tapcoin/index-c-btn-bg.png": 80124,
	"./tapcoin/index-icon-big-coin.png": 57569,
	"./tapcoin/index-icon-bronze.png": 45580,
	"./tapcoin/index-icon-energy.png": 58052,
	"./tapcoin/index-icon-level.png": 75009,
	"./tapcoin/index-icon-pph.png": 76938,
	"./tapcoin/index-icon-small-coin.png": 68841,
	"./tapcoin/index-icon-squad-1.png": 98556,
	"./tapcoin/index-icon-squad.png": 21273,
	"./tapcoin/index-icon-wallet.png": 82472,
	"./tapcoin/inset-bg-1.jpg": 88991,
	"./tapcoin/inset-bg.jpg": 62836,
	"./tapcoin/join-icon-frens.png": 25786,
	"./tapcoin/lbank.jpg": 87678,
	"./tapcoin/level/Bronze.png": 81649,
	"./tapcoin/level/Diamond.png": 17308,
	"./tapcoin/level/Emerald.png": 39975,
	"./tapcoin/level/Gold.png": 88027,
	"./tapcoin/level/Platinum.png": 96604,
	"./tapcoin/level/Ruby.png": 29676,
	"./tapcoin/level/Silver.png": 97004,
	"./tapcoin/level/Wish.png": 85792,
	"./tapcoin/loading.gif": 28272,
	"./tapcoin/lock.png": 72193,
	"./tapcoin/logo.png": 94623,
	"./tapcoin/lottery-icon.png": 55375,
	"./tapcoin/luckcode.png": 49349,
	"./tapcoin/lucky/key.png": 64765,
	"./tapcoin/lucky/light1.png": 94421,
	"./tapcoin/lucky/light2.png": 73133,
	"./tapcoin/lucky/lucky-bg.jpg": 85774,
	"./tapcoin/lucky/lucky-btn-bg.png": 2548,
	"./tapcoin/lucky/lucky-item-bg.png": 48012,
	"./tapcoin/lucky/lucky-result-coin-tap.png": 55788,
	"./tapcoin/lucky/lucky-result-coin-tapcoins.png": 16414,
	"./tapcoin/lucky/lucky-result-coin-tapstock.png": 43375,
	"./tapcoin/lucky/lucky-result-coin-ton.png": 82649,
	"./tapcoin/lucky/lucky-result-coin-usdt.png": 11104,
	"./tapcoin/lucky/lucky-result-light.png": 60268,
	"./tapcoin/lucky/tap.png": 35092,
	"./tapcoin/lucky/tapcoins.png": 78565,
	"./tapcoin/lucky/ton.png": 52808,
	"./tapcoin/lucky/usdt.png": 5976,
	"./tapcoin/luckybox/bought-bg.png": 77765,
	"./tapcoin/luckybox/box/1.png": 74891,
	"./tapcoin/luckybox/box/11.png": 30398,
	"./tapcoin/luckybox/box/2.png": 59330,
	"./tapcoin/luckybox/box/21.png": 87336,
	"./tapcoin/luckybox/box/3.png": 11363,
	"./tapcoin/luckybox/box/31.png": 16370,
	"./tapcoin/luckybox/box/4.png": 1188,
	"./tapcoin/luckybox/box/41.png": 85447,
	"./tapcoin/luckybox/box/5.png": 92037,
	"./tapcoin/luckybox/box/51.png": 51508,
	"./tapcoin/luckybox/box/6.png": 21910,
	"./tapcoin/luckybox/box/61.png": 90135,
	"./tapcoin/luckybox/leaderboard.png": 32395,
	"./tapcoin/luckybox/luckybox-hd.png": 76390,
	"./tapcoin/luckybox/luckybox-hd1.png": 81015,
	"./tapcoin/luckybox/luckybox-item-bg.png": 39889,
	"./tapcoin/luckybox/records.png": 2017,
	"./tapcoin/menu-bg.png": 5620,
	"./tapcoin/mexc.jpg": 95897,
	"./tapcoin/new/30tip.png": 10411,
	"./tapcoin/new/CRY.png": 61764,
	"./tapcoin/new/TAP-small.png": 24460,
	"./tapcoin/new/TAP.png": 63297,
	"./tapcoin/new/TAPCOINS-small.png": 9474,
	"./tapcoin/new/TAPCOINS.png": 12129,
	"./tapcoin/new/TAPSTOCK-small.png": 12337,
	"./tapcoin/new/TAPSTOCK.png": 68715,
	"./tapcoin/new/TON.png": 5418,
	"./tapcoin/new/USDT-small.png": 4943,
	"./tapcoin/new/USDT.png": 56595,
	"./tapcoin/new/avatar/avatar-1.png": 24774,
	"./tapcoin/new/avatar/avatar-2.png": 93337,
	"./tapcoin/new/avatar/avatar-3.png": 2025,
	"./tapcoin/new/avatar/avatar-4.png": 28018,
	"./tapcoin/new/avatar/avatar-5.png": 25571,
	"./tapcoin/new/avatar/index-bg-basic.jpg": 24435,
	"./tapcoin/new/avatar/index-bg-basic1.jpg": 8801,
	"./tapcoin/new/avatar/index-bg-basic2.jpg": 26331,
	"./tapcoin/new/blind/bind-box.png": 16670,
	"./tapcoin/new/blind/bind-item-bg.jpg": 67404,
	"./tapcoin/new/blind/bind-select.png": 31329,
	"./tapcoin/new/blind/blind-container-bg.png": 65899,
	"./tapcoin/new/blind/blind-items-board.png": 29146,
	"./tapcoin/new/blind/reward-box.png": 39264,
	"./tapcoin/new/blind/reward-select.png": 6608,
	"./tapcoin/new/btn-scan.jpg": 77336,
	"./tapcoin/new/gift-selector-arrow.png": 53981,
	"./tapcoin/new/gift-selector.png": 21226,
	"./tapcoin/new/gift/gift-exclusise-img.png": 89505,
	"./tapcoin/new/gift/gift-high-img.png": 11073,
	"./tapcoin/new/gift/gift-img.jpg": 70129,
	"./tapcoin/new/hot.png": 3785,
	"./tapcoin/new/icon-diamond.png": 93365,
	"./tapcoin/new/icon-gold-1.png": 22444,
	"./tapcoin/new/icon-group.png": 76515,
	"./tapcoin/new/icon-menu.png": 70354,
	"./tapcoin/new/icon-ok.png": 37674,
	"./tapcoin/new/icon-profit.png": 67918,
	"./tapcoin/new/icon-ranking.png": 98853,
	"./tapcoin/new/icon-wallet.png": 16864,
	"./tapcoin/new/index-bg-gold.png": 33292,
	"./tapcoin/new/index-icon-boosts.png": 38663,
	"./tapcoin/new/index-icon-crypto.png": 91607,
	"./tapcoin/new/index-icon-frens.png": 67993,
	"./tapcoin/new/index-icon-progress.png": 59021,
	"./tapcoin/new/index-icon-slots.png": 4282,
	"./tapcoin/new/index-icon-spin.png": 50241,
	"./tapcoin/new/lock/avatar-lock-bg.jpg": 92930,
	"./tapcoin/new/lock/avatar-lock-l.png": 76149,
	"./tapcoin/new/lock/avatar-lock-s.png": 5386,
	"./tapcoin/new/lock/double_p.png": 45844,
	"./tapcoin/new/lock/gift-1.png": 43010,
	"./tapcoin/new/lock/gift-2.png": 69894,
	"./tapcoin/new/lock/gift-3.png": 37356,
	"./tapcoin/new/machine/machine-arrow.png": 17336,
	"./tapcoin/new/machine/machine-bg.png": 5455,
	"./tapcoin/new/machine/machine-btn1-bg-1.png": 29058,
	"./tapcoin/new/machine/machine-btn1-bg.png": 87662,
	"./tapcoin/new/machine/machine-btn2-bg-1.png": 73990,
	"./tapcoin/new/machine/machine-btn2-bg.png": 60726,
	"./tapcoin/new/machine/machine-main-bg.png": 92956,
	"./tapcoin/new/machine/machine-page-bg.jpg": 13637,
	"./tapcoin/new/machine/machine-title.png": 39551,
	"./tapcoin/new/menu-active-bg.png": 36962,
	"./tapcoin/new/menu-airdrop-active.png": 84387,
	"./tapcoin/new/menu-airdrop.png": 19842,
	"./tapcoin/new/menu-app-active.png": 2627,
	"./tapcoin/new/menu-app.png": 93024,
	"./tapcoin/new/menu-bg.png": 48030,
	"./tapcoin/new/menu-earn-active.png": 35656,
	"./tapcoin/new/menu-earn.png": 78194,
	"./tapcoin/new/menu-gift-active.png": 10321,
	"./tapcoin/new/menu-gift.png": 47003,
	"./tapcoin/new/menu-home-active.png": 11681,
	"./tapcoin/new/menu-home.png": 30399,
	"./tapcoin/new/menu-study-active.png": 63565,
	"./tapcoin/new/menu-study.png": 53568,
	"./tapcoin/new/menu-tasks-active.png": 27283,
	"./tapcoin/new/menu-tasks.png": 23570,
	"./tapcoin/new/nav-bg.jpg": 77843,
	"./tapcoin/new/nav-icon-achievements.png": 96289,
	"./tapcoin/new/nav-icon-bounty.png": 18689,
	"./tapcoin/new/nav-icon-code.png": 4169,
	"./tapcoin/new/nav-icon-login.png": 82097,
	"./tapcoin/new/new.png": 76794,
	"./tapcoin/new/niceLucky/btn-1.png": 70699,
	"./tapcoin/new/niceLucky/btn-2.png": 72564,
	"./tapcoin/new/niceLucky/icon-buy.png": 77947,
	"./tapcoin/new/niceLucky/icon-invite.png": 15850,
	"./tapcoin/new/niceLucky/icon-shard.png": 82170,
	"./tapcoin/new/niceLucky/icon-ship.png": 54684,
	"./tapcoin/new/niceLucky/icon-task.png": 53731,
	"./tapcoin/new/niceLucky/light.png": 22540,
	"./tapcoin/new/niceLucky/nft-bg.jpg": 74418,
	"./tapcoin/new/niceLucky/niceLucky-bottom.png": 52706,
	"./tapcoin/new/niceLucky/niceLucky-item-active-bg.png": 26666,
	"./tapcoin/new/niceLucky/niceLucky-item-bg.png": 53468,
	"./tapcoin/new/niceLucky/niceLucky.png": 13243,
	"./tapcoin/new/niceLucky/niceLucky_title.png": 2036,
	"./tapcoin/new/niceLucky/niceLucy-bg.jpg": 57808,
	"./tapcoin/new/niceLucky/ship-num.png": 42450,
	"./tapcoin/new/perHour.png": 88043,
	"./tapcoin/okwallet-logo.png": 36863,
	"./tapcoin/okx.jpg": 38297,
	"./tapcoin/okxwallet-live.png": 52338,
	"./tapcoin/okxwallet-top.png": 19501,
	"./tapcoin/pop-award-icon-0.png": 79986,
	"./tapcoin/pop-coin-hero-icon-0.png": 63230,
	"./tapcoin/pop-up-gold-icon-0.png": 9611,
	"./tapcoin/premium-s.png": 93685,
	"./tapcoin/premium.png": 69018,
	"./tapcoin/proof.jpg": 29206,
	"./tapcoin/rank-1.png": 19162,
	"./tapcoin/rank-2.png": 32030,
	"./tapcoin/rank-3.png": 78368,
	"./tapcoin/rank-bronze.png": 44222,
	"./tapcoin/robot-logo.jpg": 52541,
	"./tapcoin/scan-head.jpg": 40072,
	"./tapcoin/sd.png": 18773,
	"./tapcoin/sign-calendar-ok.png": 36468,
	"./tapcoin/sign-calendar.png": 18976,
	"./tapcoin/sign-premium.png": 96936,
	"./tapcoin/solojack-tip.png": 57211,
	"./tapcoin/squad-icon-1.png": 54583,
	"./tapcoin/squad-icon-2.png": 44481,
	"./tapcoin/squad-icon-3.png": 3355,
	"./tapcoin/squad-icon-4.png": 83051,
	"./tapcoin/start.png": 8059,
	"./tapcoin/tap.png": 30909,
	"./tapcoin/task-detail-arrow.png": 50056,
	"./tapcoin/task-detail-arrow2.png": 88161,
	"./tapcoin/task-detail-bg.jpg": 68183,
	"./tapcoin/task-detail-step-1.jpg": 82173,
	"./tapcoin/task-detail-step-2.jpg": 50133,
	"./tapcoin/task-detail-step-3.jpg": 4134,
	"./tapcoin/task-detail-step-4.jpg": 26725,
	"./tapcoin/tickets.png": 73780,
	"./tapcoin/time.png": 92661,
	"./tapcoin/tip.png": 62136,
	"./tapcoin/ton-add.png": 5929,
	"./tapcoin/ton-stars.png": 92550,
	"./tapcoin/tron.png": 89486,
	"./tapcoin/turbo.png": 11278,
	"./tapcoin/unknown.png": 70001,
	"./tapcoin/up.png": 570,
	"./tapcoin/usdt-p.png": 65984,
	"./tapcoin/usdt.png": 44777,
	"./tapcoin/zbx.jpg": 78155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51964;